import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';

class OutMeasureDropDown extends React.Component {

    updateField(event) {
        let key = undefined;
        key = Object.keys(this.props.masterOutcomes)
            .find(x => this.props.masterOutcomes[x].MOUNAME === event.target.value);
        if (key === undefined) {
            this.props.clearField(this.props.noteId, 'PTOUTMEASURES', 'OMNO', this.props.entityKeyValue, 'OMMOUNO');
            this.props.clearField(this.props.noteId, 'PTOUTMEASURES', 'OMNO', this.props.entityKeyValue, 'OMNAME');
        } else {
            this.props.updateIntField(this.props.noteId, 'PTOUTMEASURES', 'OMNO', this.props.entityKeyValue, 'OMMOUNO', this.props.masterOutcomes[key].MOUNO);
            if (this.props.masterOutcomes[key].MOUNAME !== 'Other') {
                this.props.updateTextField(this.props.noteId, 'PTOUTMEASURES', 'OMNO', this.props.entityKeyValue, 'OMNAME', this.props.masterOutcomes[key].MOUNAME);
            } else {
                this.props.clearField(this.props.noteId, 'PTOUTMEASURES', 'OMNO', this.props.entityKeyValue, 'OMNAME');
            }
        }
        if (this.props.onChange) {
            this.props.onChange({ ...event, key });
        }
    }

    render() {
        return (
            <span>

                <select
                    title={this.props.title ? this.props.title : ''}
                    value={this.props.value ? this.props.value : -1}
                    name='OMMOUNO'
                    className={this.props.className ? this.props.className : ''}
                    disabled={this.props.disabled}
                    onChange={(event) => this.updateField(event)}
                >
                    <option key={-1} value={-1}></option>
                    {Object.keys(this.props.masterOutcomes)
                        .map(key => {
                            const result = this.props.masterOutcomes[key];
                            return (
                                <option key={result.MOUNO} value={result.MOUNAME} >{result.MOUNAME}</option>
                            )
                        })
                    }
                </select>
            </span>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let isPeds = state.entities.admissions[ownprops.epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isSpeech = state.entities.admissions[ownprops.epno].discipline === "ST" ? true : false;
    let isSpeechPeds = state.entities.admissions[ownprops.epno].isPedsSpeech;

    return {
        value: state.entities.notes.PTOUTMEASURES[ownprops.entityKeyValue].OMMOUNO ?
            state.entities.masterData.PTMASTEROUTCOMES[state.entities.notes.PTOUTMEASURES[ownprops.entityKeyValue].OMMOUNO].MOUNAME : undefined,
        maxLength: state.entities.masterData.PTERONOTESCHEMA['PTOUTMEASURES.OMNAME'].CHARACTER_MAXIMUM_LENGTH,
        masterOutcomes: Object.keys(state.entities.masterData.PTMASTEROUTCOMES)
            .filter(key => {
                return ((state.entities.masterData.PTMASTEROUTCOMES[key].MOUMOUTNO === 1 && !(isPeds && isPedsEnabled) && !(isSpeechEnabled && isSpeech))
                    || (isPeds && !isSpeechPeds && isPedsEnabled && state.entities.masterData.PTMASTEROUTCOMES[key].MOUMOUTNO === 2)
                    || (isSpeech && isSpeechEnabled && state.entities.masterData.PTMASTEROUTCOMES[key].MOUMOUTNO === 3)
                )
            })
            .sort((a, b) => state.entities.masterData.PTMASTEROUTCOMES[a].MOUORDER - state.entities.masterData.PTMASTEROUTCOMES[b].MOUORDER)
            .map(key => state.entities.masterData.PTMASTEROUTCOMES[key])

    };
}

const connectedOutMeasureDropDown = connect(mapStateToProps, mapDispatchToProps)(OutMeasureDropDown);
export { connectedOutMeasureDropDown as OutMeasureDropDown };